import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/brand/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/brand/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/brand/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/brand/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/brand/delete/${id}`)
}
